import { Component, OnInit } from "@angular/core";
import { JobStatusService } from "../../jobStatus/jobStatus.service";

@Component({
  selector: "min-days-enrolled-input",
  templateUrl: "./min-days-enrolled-input.component.html",
  styleUrls: ["./min-days-enrolled-input.component.scss"],
})
export class MinDaysEnrolledInputComponent implements OnInit {
  constructor(public jobStatusService: JobStatusService) {}
  invalidInput: boolean = false;

  ngOnInit() {}

  validate(value) {
    this.invalidInput = value.includes(".") || value == "" || isNaN(value);
    this.jobStatusService.hasMinDaysInputError = this.invalidInput;
  }
}
